import { useState } from "react";

import OperationalAuditPanel from "@/components/OperationalAuditPanel";
import QuoteAuditPanel from "@/components/QuoteAuditPanel";

export default function AuditPage() {
  const [view, setView] = useState("quotes");

  return (
    <section className="page audit-page" data-testid="audit-page">
      <header className="page-header compact">
        <div>
          <span className="eyebrow">TRAZABILIDAD COMERCIAL</span>
          <h1>Auditoría comercial</h1>
          <p>Consulta responsables, reservas y cada modificación realizada sobre un lote.</p>
        </div>
      </header>
      <div className="audit-view-switcher" data-testid="audit-view-switcher">
        <button
          className={view === "quotes" ? "selected" : ""}
          data-testid="audit-quotes-view-button"
          onClick={() => setView("quotes")}
          type="button"
        >
          Cotizaciones
        </button>
        <button
          className={view === "reservations" ? "selected" : ""}
          data-testid="audit-reservations-view-button"
          onClick={() => setView("reservations")}
          type="button"
        >
          Reservas y ventas
        </button>
        <button
          className={view === "lots" ? "selected" : ""}
          data-testid="audit-lots-view-button"
          onClick={() => setView("lots")}
          type="button"
        >
          Modificaciones de lotes
        </button>
      </div>
      {view === "quotes" && <QuoteAuditPanel />}
      {view !== "quotes" && <OperationalAuditPanel category={view} />}
    </section>
  );
}
